import React from 'react'

import './no-data.scss'
// import { ReactComponent as DataIcon } from 'assets/img/book-line.svg'

const NoDataState = (
    {
        itemType,
        desc,
        icon
    }: {
        itemType: string
            desc?: string
            icon?: JSX.Element
    }) => {
    return (
        <div className='no-data-container'>
            {
                icon ?
                    <div className={`no-data-container__icon ${itemType && itemType.includes('workflows') ? 'workflows-icon' : ''}`}>
                        {icon && icon}
                    </div>
                    :
                    <></>
            }
            <h1>{itemType}</h1>
            <span>{desc}</span>
        </div>
    )
}

export default NoDataState